export const DATE_FORMAT_GROUPS = {
  MDY: ["en-us", "en-ca", "en-ph", "en-bz", "en-pw"],
  DMY: [
    "en-gb", "en-ie", "en-au", "en-nz", "en-in", "en-pk",
    "en-za", "en-ng", "en-ke", "en-lk",
    "fr", "fr-fr", "fr-ca",
    "de", "de-de", "de-at", "de-ch",
    "es", "es-es", "es-mx", "es-ar", "es-cl", "es-co",
    "it", "it-it",
    "pt", "pt-pt", "pt-br",
    "nl", "nl-nl", "nl-be",
    "pl", "cs", "sk", "hu", "ro", "bg",
    "sv", "no", "da", "fi",
    "ru", "uk", "sr", "hr", "sl",
    "ar", "ar-sa", "ar-eg",
    "tr", "he",
    "fa",
    "id", "ms",
    "hi", "bn", "ta", "te", "ml"
  ],
  YMD: [
    "ja", "ja-jp",
    "ko", "ko-kr",
    "zh", "zh-cn",
    "zh-tw",
    "zh-hk",
    "vi",
    "th",
    "mn",
    "hu-hu"
  ]
};

export const DATE_REGEX = {
  MDY: /^(\d{1,2})([./-])(\d{1,2})\2(\d{4})$/,
  DMY: /^(\d{1,2})([./-])(\d{1,2})\2(\d{4})$/,
  YMD: /^(\d{4})([./-])(\d{1,2})\2(\d{1,2})$/
};